import Model, { attr, hasMany } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsCardModel from './pcs-card.ts';
import type PcsCompanyModel from './pcs-company.ts';

export default class PcsProviderModel extends Model {
  @attr declare description: string;
  @attr declare metadata: Record<string, unknown>;

  /*************************
   **  Relationships      **
   *************************/

  @hasMany('pcs-company', { async: false, inverse: 'pcsProvider' })
  declare pcsCompanies: PcsCompanyModel[];

  @hasMany('pcs-card', { async: false, inverse: 'pcsProvider' })
  declare pcsCards: PcsCardModel[];

  [Type] = 'pcs-provider' as const;
}
